import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { UsersDataRequestPayloadTypes } from '../models/user-management';

const SecretManagerService = {
  fetchTemplates: async (payload?: UsersDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.SECRET_MANAGER_BASE_URL + '/templates', { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchTemplateById: async (payload?: UsersDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.SECRET_MANAGER_BASE_URL + '/templates/get', { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addNewTemplate: async (payload: object) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.SECRET_MANAGER_BASE_URL + '/templates/create', payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateTemplate: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(apiPath.SECRET_MANAGER_BASE_URL + '/templates/update/' + payload.template_id, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  deleteTemplate: async (payload: any) => {
    try {
      // const reqParams = payload.map((item: any) => {
      //   return item;
      // });

      // const apiResponse = await axiosClient.delete(apiPath.SECRET_MANAGER_BASE_URL + '/templates/delete', {
      //   data: { user_ids: [...reqParams] },
      // });

      const apiResponse = await axiosClient.delete(apiPath.SECRET_MANAGER_BASE_URL + '/templates/delete/'+payload.template_id);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchSecrets: async (payload: any) => {
    try {      
      const apiResponse: any = await axiosClient.get(apiPath.SECRET_MANAGER_BASE_URL + '/get',{ params: payload });     
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {      
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchSecretById: async (payload: any) => {
    try {      
      const apiResponse: any = await axiosClient.get(apiPath.SECRET_MANAGER_BASE_URL + '/read/' + payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addNewSecret: async (payload: object) => {
    try {      
      const apiResponse = await axiosClient.post(apiPath.SECRET_MANAGER_BASE_URL + '/create', payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateSecrets: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(apiPath.SECRET_MANAGER_BASE_URL + '/update/' + payload.secret_id, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  deleteSecrets: async (payload: any) => {
    try {      
      const apiResponse = await axiosClient.delete(apiPath.SECRET_MANAGER_BASE_URL + '/delete/'+payload.secret_id);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default SecretManagerService;
